import React,{useState,useEffect} from 'react'
import { url } from '../../App';
import {BoxSkill,Img,Title,Description,ReadMore} from '../../globalStyle'
import ImageError from '../error/error';
import Skeleton from '../skeleton/skeleton';

function Skill(){
    const [ data, setData ] = useState([]);

    const [loading, setLoading] = useState(false)
    const [error,setError] = useState(false)

    async function getSkill(){
        setLoading(true)
        try{
            let res = await fetch(`${url}/get-skill`)
            let data = await res.json()
            setData(data.data)
        }catch(error){
            setError(true)
        }finally{
            setLoading(false)
        }
    }
    useEffect(() => {
      getSkill()
      return()=>{
          getSkill()
      }
    },[])
    
   if(error){
       return(
           <ImageError />
       )
   }
   if(loading){
       return(
        <Skeleton width={"250px"} height={"320px"} amount={4} />

       )
   }
    return(
        <>
            {
                
                data.map(item=>{
                    return(
                    <BoxSkill key={item.id}>
                        <Img src={item.image} alt="Skill" />
                        <Title>{item.nama}</Title>
                        <Description>{item.body.substr(0,40) + '...'}</Description>
                        <ReadMore to={'/skills/'+item.id} >read more</ReadMore>
                    </BoxSkill>
                    )
                })

            }
        </>
    )


}

export default Skill;